import React from "react"

import "./styles.scss"

const Header = props => (
    <section className="row header">
    </section>
)

export default Header